import React, { PropTypes, Component } from 'react';

class Background extends Component {
  render() {
    return (
      <g {...this.props} className="social-svg-background">
        <circle cx="32" cy="32" r="31"/>
      </g>
    );
  }
}

export default Background;



/** WEBPACK FOOTER **
 ** ./src/components/Icons/background.js
 **/